
export enum AgendaItemStatusCd {
	CANCELLED = 'Cancelled',
	MET = 'Met',
	NOT_DUE = 'Not Due',
	NOT_MET = 'Not Met'}

